var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-container",attrs:{"id":_vm.generateUniqueId,"data-token":_vm.resource.url,"data-config":"{\"autoPlay\":\"true\",\"startMuted\":\"true\",\"loop\":\"false\"}"}})
}
var staticRenderFns = []

export { render, staticRenderFns }